import { Dispatch } from "../../../controller";
import { TabelaPrecoConfig } from "../../../data.types";
import { Model,StateProps } from "../../../model";

export type { TabelaPrecoConfig } from "../../../data.types";

export interface TabelaPrecoState extends StateProps<TabelaPrecoConfig> {
 
}

export interface TabelaPrecoActions extends Dispatch<TabelaPrecoConfig> {

}

const model = new Model<TabelaPrecoConfig,TabelaPrecoState>("tabelapreco");

const intialValueTabelaPrecoConfig:TabelaPrecoConfig = {
    ...model.getInitialValue(),
    type:"tabelapreco",
    descricao:"",
    ativo:true,

}

export const initialValueTabelaPrecoState:TabelaPrecoState = {
    ...model.getInititalValueState(),
    row:intialValueTabelaPrecoConfig,
}


